// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopGooglePayControllerGetGooglePayEchoData } from './EshopGooglePayControllerGetGooglePayEchoData.gen';
import type { EshopGooglePayControllerGetGooglePayEchoErrors } from './EshopGooglePayControllerGetGooglePayEchoErrors.gen';
import type { EshopGooglePayControllerGetGooglePayEchoResponses } from './EshopGooglePayControllerGetGooglePayEchoResponses.gen';
import type { EshopGooglePayControllerInitGooglePayPaymentData } from './EshopGooglePayControllerInitGooglePayPaymentData.gen';
import type { EshopGooglePayControllerInitGooglePayPaymentErrors } from './EshopGooglePayControllerInitGooglePayPaymentErrors.gen';
import type { EshopGooglePayControllerInitGooglePayPaymentResponses } from './EshopGooglePayControllerInitGooglePayPaymentResponses.gen';
import type { EshopGooglePayControllerProcessGooglePayPaymentData } from './EshopGooglePayControllerProcessGooglePayPaymentData.gen';
import type { EshopGooglePayControllerProcessGooglePayPaymentErrors } from './EshopGooglePayControllerProcessGooglePayPaymentErrors.gen';
import type { EshopGooglePayControllerProcessGooglePayPaymentResponses } from './EshopGooglePayControllerProcessGooglePayPaymentResponses.gen';
import type { Options } from './Options.gen';

export class EshopGooglePayController {
    /**
     * Returns Google Pay configuration parameters required for client-side initialization.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **GOOGLE_PAY_ECHO_ERROR** - Error from payment gateway echo.
     */
    public static getGooglePayEcho<ThrowOnError extends boolean = false>(options?: Options<EshopGooglePayControllerGetGooglePayEchoData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopGooglePayControllerGetGooglePayEchoResponses, EshopGooglePayControllerGetGooglePayEchoErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/payments/google-pay/echo',
            ...options
        });
    }
    
    /**
     * Initializes a new Google Pay payment at the payment gateway.
     *
     * Returns the gateway response. When it contains `actions.fingerprint.browserInit`, the client must perform the device fingerprint (load the URL in a hidden iframe) and then call `/process`.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **ORDER_USER_MISMATCH** - The order and logged user doesn't match.
     */
    public static initGooglePayPayment<ThrowOnError extends boolean = false>(options: Options<EshopGooglePayControllerInitGooglePayPaymentData, ThrowOnError>) {
        return (options.client ?? client).post<EshopGooglePayControllerInitGooglePayPaymentResponses, EshopGooglePayControllerInitGooglePayPaymentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/payments/google-pay/init',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Processes an initialized Google Pay payment (after the optional device fingerprint).
     *
     * Returns the gateway response. When it contains `actions.authenticate.browserChallenge`, the client must open the URL (3DS challenge); the customer is then redirected back to the eshop return URL.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **ORDER_USER_MISMATCH** - The order and logged user doesn't match.<br>
     * + **CANNOT_INIT_PAYMENT** - CSOB Gateway cannot be initialized.
     */
    public static processGooglePayPayment<ThrowOnError extends boolean = false>(options: Options<EshopGooglePayControllerProcessGooglePayPaymentData, ThrowOnError>) {
        return (options.client ?? client).post<EshopGooglePayControllerProcessGooglePayPaymentResponses, EshopGooglePayControllerProcessGooglePayPaymentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/payments/google-pay/process',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
